import React, { useMemo } from 'react';
import * as FlagIcons from 'country-flag-icons/react/3x2';

/**
 * Renders a country flag icon based on ISO country code.
 *
 * @param country - ISO country code (e.g., 'US', 'GB', 'JP')
 * @param size - Width of the flag in pixels (default: 16)
 * @returns Flag icon or null if country code is invalid
 */
const Flag: React.FC<{ country?: string; size?: number }> = ({
  country,
  size = 16,
}) => {
  const code = (country ?? '').toUpperCase();
  const Cmp = useMemo(() => {
    if (!code) return null;
    return (
      (
        FlagIcons as unknown as Record<
          string,
          React.ComponentType<React.SVGProps<SVGSVGElement>>
        >
      )[code] ?? null
    );
  }, [code]);

  if (!Cmp) return null;

  return (
    <Cmp
      role='img'
      aria-label={code}
      style={{
        width: size,
        height: Math.round((size * 2) / 3),
        marginRight: 6,
        verticalAlign: '-2px',
        display: 'inline-block',
      }}
    >
      <title>{code}</title>
    </Cmp>
  );
};

export default Flag;
